import React from 'react'
import ConfirmOnClickPipeline from 'support/pipelines/ConfirmOnClickPipeline'
import { ExecuteOperationForModelOnPipe, ExecuteOperationOnPipe, useOperation } from '@morningtrain/react-resources'
import * as Auth from '@morningtrain/react-auth'
import { NestedAsyncPipeline, NestedPipeline } from '@morningtrain/react-pipelines'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'

export default function CustomAction ({
  trigger = null,
  content = null,
  namespace = 'api',
  resourceName = null,
  operationName = null,
  action = null,
  translationName = null,
  buttonProps = {},
  refreshParent = true,
  children
}) {
  const parentOperation = useOperation()
  const resource = parentOperation.resource

  const _namespace = namespace || resource.namespace || 'api'
  const _resourceName = resourceName || resource.slug
  const _operationName = action || operationName

  const _trigger = trigger || (
    <UI.Button {...buttonProps}>
      <Translation name={translationName || 'actions.' + _operationName} />
    </UI.Button>
  )

  return (
    <Auth.CanUseModel permission={[_namespace, _resourceName, _operationName].join('.')}>
      <ConfirmOnClickPipeline trigger={_trigger} content={content}>
        <ExecuteOperationForModelOnPipe namespace={_namespace} resourceName={_resourceName} operationName={_operationName} />
        <NestedPipeline>
          {!refreshParent
            ? null
            : (
              <ExecuteOperationOnPipe namespace={resource.namespace} resourceName={resource.slug} operationName={parentOperation.slug} />
              )}
          {children}
        </NestedPipeline>
      </ConfirmOnClickPipeline>
    </Auth.CanUseModel>
  )
}
